import { FormattedMessage } from "react-intl";

import { htmlLink, url } from "../../utils";
import Heading from "../Heading";
import { errorTypes } from "./ErrorTypes";
import ErrorNavigationBar from "./ErrorNavigationBar";
import Template from "../../layouts/Template";
import Icon from "../Icon";
import { sentryUnmask } from "../../utils/sentryUtils";
import { Container } from "../Grid";

type Props = {
  details: string;
  errorType?: number;
  header: string;
  isFullPage?: boolean;
};

// When React crashes, or hub crashes (ex: React-router is unavailable, or config is unavailable)
export function ErrorPage({
  details,
  errorType,
  header,
  isFullPage = false,
}: Props) {
  const pictureUrl =
    {
      [errorTypes.not_found]: "/images/failure_screens_plug.png",
      [errorTypes.forbidden]: "/images/failure_screens_lock.png",
      [errorTypes.unknown]: "/images/failure_screens_repair.png",
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    }[errorType] || "/images/failure_screens_plug.png";

  const backButton = (
    <div style={{ textAlign: "left" }}>
      <button
        className="back-button"
        onClick={() => {
          // do not use react-router here because it might be unavailable
          /* eslint-disable-next-line no-restricted-globals */
          window.history.back();
        }}
        type="button"
      >
        <Icon name="icon-eh-arrow-left" />
        <span>
          <FormattedMessage id="label.go_back" />
        </span>
      </button>
    </div>
  );

  const errorBanner = (
    <Container>
      <div className={sentryUnmask("centered-div")}>
        {backButton}
        <Heading id="error-page-header" title={header} />
        <div className="space-after">
          <p id="error-page-details" className="error-details">
            {details}
          </p>
        </div>
        <p>
          <FormattedMessage
            id="error_page.message"
            values={{
              // @ts-expect-error TS(2322) FIXME: Type '(...chunks: any[]) => Element' is not assign... Remove this comment to see the full error message
              home: htmlLink({ href: "/" }),
              // @ts-expect-error TS(2322) FIXME: Type '(...chunks: any[]) => Element' is not assign... Remove this comment to see the full error message
              contact: htmlLink({
                href: "https://netilion.endress.com/support/contact",
              }),
            }}
          />
        </p>
        <div className="error-picture-div sentry-unblock">
          <img
            className="img-responsive error-picture"
            src={url(pictureUrl)}
            alt={header}
          />
        </div>
      </div>
    </Container>
  );

  return isFullPage ? (
    <>
      <ErrorNavigationBar />
      <div className="navbar-separator" />
      {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element; authenticated: boolean;... Remove this comment to see the full error message */}
      <Template authenticated={false}>{errorBanner}</Template>
    </>
  ) : (
    errorBanner
  );
}

export default ErrorPage;
